import dedupList from '../../utils/dedupeList'
import mapEvent from './mapEvent'
const isNotNullOrUndefined = (element) => element && element !== null

function getStateOptions(enableDataLabels, stateJson) {
  const safeFeatures = (stateJson?.features ?? []).filter(
    (f) => f && f.geometry && f.geometry.type
  )
  const safeMapData = {
    ...stateJson,
    type: 'FeatureCollection',
    features: safeFeatures,
  }

  return {
    // borderColor: 'gray',
    borderWidth: 1,
    mapData: safeMapData,
    name: 'Infections by State',
    joinBy: ['hc-a2', 'state'],
    animation: false,
    cursor: 'pointer',
    allowPointSelect: true,
    states: {
      // select: {
      //   color: null,
      //   borderColor: 'gray',
      // },
      hover: {
        brightness: 0,
        borderColor: 'green',
      },
    },
    dataLabels: {
      enabled: enableDataLabels,
      useHTML: false,
      // format: '{point.hc-a2}',
      formatter: function () {
        return (
          '<div style="border:solid 1px;color:black;padding:0.5em;text-align:center;font-size: 12px;background: #FAE0DA;text-shadow: 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.3em white, 0 0 0.4em white;">' +
          this.point.state +
          '</div>'
        )
      },
    },
  }
}

function getCbsaOptions(activeCbsas, jsonFile, mapType) {
  const ids = Array.isArray(activeCbsas) ? activeCbsas : []
  const safeFeatures = (jsonFile?.features ?? [])
    .filter((f) => f && f.properties && ids.includes(f.properties.geoid))
    .filter((f) => f.geometry && f.geometry.type)

  //const safeFeatures = (cbsaJson?.features ?? []).filter(f => f && f.geometry && f.geometry.type);

  const filteredMapData = {
    ...jsonFile,
    type: 'FeatureCollection',
    features: safeFeatures,
  }
  let joinByArray = []
  if (mapType !== undefined && mapType === 'FLUMAP') {
    joinByArray = ['geoid', 'cbsa']
  } else {
    joinByArray = ['geoid', 'state']
  }

  return {
    borderColor: 'gray',
    borderWidth: 1,
    mapData: filteredMapData,
    name: 'Infection rate',
    dataLabels: {
      enabled: false,
      //format: '{point.cbsa}',
      formatter: function () {
        return '<div style="border:solid 1px;color:black;padding:0.5em;text-align:center;font-size: 12px;background: #FAE0DA;text-shadow: 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.3em white, 0 0 0.4em white;">' +
          mapType !==
          undefined && mapType === 'FLUMAP'
          ? this.point?.cbsa
          : this.point?.geo_name + '</div>'
      },
    },
    allAreas: false,
    joinBy: joinByArray,
    animation: false,
    cursor: 'pointer',
    allowPointSelect: true,
    states: {
      // select: {
      //   color: null,
      //   borderColor: 'gray',
      // },
      hover: {
        brightness: 0,
        borderColor: 'gray',
      },
    },

    // nullColor: 'transparent'
  }
}
function getMSAOptions(cbsaJson) {
  return {
    borderColor: 'gray',
    borderWidth: 1,
    mapData: cbsaJson,
    name: 'Infections by MSA',
    joinBy: ['cbsa', 'cbsa'],
    animation: false,
    cursor: 'pointer',
    allowPointSelect: true,
    states: {
      select: {
        color: null,
        borderColor: 'gray',
      },
      hover: {
        borderColor: 'green',
      },
    },
    dataLabels: {
      enabled: false,
      format: '{point.hc-a2}',
    },
  }
}

function getZip3Options(activeZip3, enableDataLabels, zip3Json, zoomLocation) {
  // const ids = Array.isArray(activeZip3) ? activeZip3 : []

  //   zip3Json.features.forEach(f => {
  //   if (f.properties && f.properties.geoid) {
  //     f.properties.geoid = String(f.properties.geoid).padStart(3, '0');
  //   }
  // });

  const ids = Array.isArray(activeZip3)
    ? activeZip3.map((z) => String(z).padStart(3, '0'))
    : []
  zip3Json.features?.forEach((f) => {
    if (f?.properties?.geoid && ids.includes(f.properties.geoid)) {
      f.properties.geoid = String(f.properties.geoid).padStart(3, '0')
    }
  })

  //const ids = Array.isArray(activeZip3) ? activeZip3.map(z => String(z).padStart(3, '0')) : [];

  // If you want all polygons visible, skip the id filter altogether:
  const safeFeatures = (zip3Json?.features ?? []).filter(
    (f) => f && f.properties && f.geometry && f.geometry.type
  )

  //const safeFeatures = zip3Json.features

  const filteredMapData = {
    ...zip3Json,
    type: 'FeatureCollection',
    features: safeFeatures,
  }

  return {
    borderColor: 'white',
    borderWidth: 1,
    mapData: filteredMapData,
    name: 'Infections by Zip3',
    joinBy: ['geoid', 'geoid'],
    animation: false,
    cursor: 'pointer',
    allowPointSelect: true,

    allAreas: false, // <-- only draw shapes that have joined data
    //nullColor: 'transparent',      // <-- don't show unmatched shapes
    zIndex: 2,
    enabled: enableDataLabels,
    states: {
      select: {
        color: null,
        borderColor: 'gray',
      },
      hover: {
        borderColor: 'green',
      },
    },
    dataLabels: {
      enabled: enableDataLabels,
      useHTML: false,
      allowOverlap: true,
      crop: false,
      overflow: 'none',
      //format: '{point.cbsa}',
      formatter: function () {
        var value =
          parseInt(zoomLocation) === parseInt(this.point.geo_id)
            ? this.point.geo_id
            : ''
        return (
          '<div style="border:solid 1px;color:black;padding:0.5em;text-align:center;font-size: 12px;background: #FAE0DA;text-shadow: 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.3em white, 0 0 0.4em white;">' +
          value +
          '</div>'
        )
      },
      // formatter: function () {
      //   var value =
      //     parseInt(zoomLocation) === parseInt(this.point.geo_id)
      //       ? this.point.geo_id
      //       : ''
      //   return (
      //     '<div style="border:solid 1px;color:black;padding:0.5em;text-align:center;font-size: 12px;background: #FAE0DA;text-shadow: 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.3em white, 0 0 0.4em white;">' +
      //     value +
      //     '</div>'
      //   )
      // },
    },
  }
}

function getCountyOptions(
  activeCounties,
  showCountyLabels = false,
  countyJsonData
) {
  return {
    borderColor: '#424242',
    nullColor: 'rgba(0, 0, 0, 0)',
    borderWidth: 0.2,
    mapData: countyJsonData,
    name: 'County Graph',
    animation: false,
    cursor: 'pointer',
    dataLabels: {
      enabled: false,
      formatter: function () {
        return (
          '<div style="border:solid 1px;color:black;padding:0.5em;text-align:center;font-size: 12px;background: #FAE0DA;text-shadow: 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.3em white, 0 0 0.4em white;">' +
          this.point.geo_name +
          '</div>'
        )
      },
    },
    allowPointSelect: false,
    states: {
      select: {
        color: null,
        borderColor: 'gray',
      },
      hover: {
        borderColor: 'gray',
      },
    },
  }
}

function getMapOptions(
  colorAxis,
  legend,
  toolTipFormatter,
  activeCbsasData,
  cbsaData,
  stateData,
  msaData,
  history,
  titleText = null,
  subtitleText = null,
  showStateLabels = true,
  enableTooltip = true,
  enableMapNavigation = true,
  enableMouseTracking = true,
  mapType,
  enableButtons,
  stateJson,
  cbsaJson,
  zip3Json,
  zip3DataFiltered,
  mapActiveZIP3Data,
  highlightCBSA,
  exportMap = false,
  showCountyLabels = false,
  showZip3Labels = true,
  showCountyBorder = true,
  zoomLocation,
  chartRef,
  toggleEnabled,
  mapDataType,
  JsonData,
  countyData,
  countyGeoJson,
  dashboardType,
  showCbsaLabels = false
) {
  let getMapState = false
  let cbsaOptions = {}
  let stateOptions = {}
  let msaOptions = {}
  let zip3Options = {}
  let countyOptions = {}

  const EMPTY_FC = { type: 'FeatureCollection', features: [] }
  const series = []

  if (isNotNullOrUndefined(stateData)) {
    const safeJson =
      stateJson?.type === 'FeatureCollection' ? stateJson : EMPTY_FC
    stateOptions = getStateOptions(showStateLabels, safeJson)
    console.log(`stateOptions map data : ${stateOptions.mapData?.type}`)
    stateOptions.visible = true
    stateOptions.data = dedupList(stateData)
    series.push(stateOptions)
  } else {
    stateOptions.visible = false
  }

  if (isNotNullOrUndefined(cbsaData)) {
    if (mapType !== undefined && mapType === 'FLUMAP') {
      const safeJson =
        cbsaJson?.type === 'FeatureCollection' ? cbsaJson : EMPTY_FC
      cbsaOptions = getCbsaOptions(activeCbsasData, safeJson, mapType)
      console.log(`CBSA map data : ${cbsaOptions.mapData?.type}`)
      cbsaOptions.visible = true
      cbsaOptions.data = dedupList(cbsaData)
      //  series.push(cbsaOptions)
    } else {
      cbsaOptions = getCbsaOptions(activeCbsasData, JsonData, mapType)
      cbsaOptions.visible = true
      cbsaOptions.data = dedupList(cbsaData)
    }
    series.push(cbsaOptions)
  } else {
    cbsaOptions.visible = false
  }

  if (isNotNullOrUndefined(zip3DataFiltered)) {
    zip3Options = getZip3Options(
      mapActiveZIP3Data,
      showZip3Labels,
      zip3Json,
      zoomLocation
    )
    zip3Options.visible = true
    zip3Options.data = dedupList(zip3DataFiltered)
    series.push(zip3Options)
  } else zip3Options.visible = false

  if (isNotNullOrUndefined(msaData)) {
    const safeJson =
      cbsaJson?.type === 'FeatureCollection' ? cbsaJson : EMPTY_FC
    msaOptions = getMSAOptions(safeJson)
    console.log(`msaOptions map data : ${msaOptions.mapData?.type}`)
    msaOptions.visible = true
    msaOptions.data = dedupList(msaData)
    series.push(msaOptions)
  }

  if (!countyGeoJson) {
    countyOptions.visible = false
  } else {
    countyOptions = getCountyOptions(
      countyData,
      showCountyLabels,
      countyGeoJson
    )
    countyOptions.visible = showCountyBorder
    countyOptions.data = []
    series.push(countyOptions)
  }


  return {
    title: {
      text: titleText,
      style: {
        color: '#424242',
        fontWeight: '700',
        //fontfamily: 'graphik',
        fontsize: '16px',
      },
      align: ['CIACCURACY', 'COVIDACC'].includes(mapType?.toUpperCase())
        ? 'center'
        : 'left',
    },
    subtitle: {
      text: subtitleText,
    },
    chart: {
      backgroundColor: 'none',
      displayErrors: false,
      events: {
        load: function () {           
          if (dashboardType === 'ALLERGIES' && mapDataType === 2) {
            let point = this.series[1]?.points.find(function (p) {
              return p.geoid === zoomLocation
            })

            setTimeout(() => {
              if (point !== null && point !== undefined) point.zoomTo()
            }, 1000)
          }
          if(dashboardType === 'uti' && mapDataType === 1){
             let point = this.series[1]?.points.find(function (p) {
              return p.geo_id === undefined
                ? p.parent === zoomLocation
                : p.geo_id === zoomLocation
            })

            setTimeout(() => {
              if (point !== null && point !== undefined)
                point.state != null && point.zoomTo()
            }, 1000)
          }
           else {
            let point = this.series[0]?.points.find(function (p) {
              return p.state === undefined
                ? p.parent === zoomLocation
                : p.state === zoomLocation
            })

            setTimeout(() => {
              if (point !== null && point !== undefined)
                point.state != null && point.zoomTo()
            }, 1000)
          }
        },
      },
    },
    colorAxis: colorAxis,
    legend: legend,
    series: series, //[stateOptions, cbsaOptions, msaOptions],
    mapNavigation: {
      enabled: enableMapNavigation,
      // enableDoubleClickZoomTo: true,
      enableMouseWheelZoom: false,
      enableButtons: enableButtons,
      buttonOptions: {
        verticalAlign: 'bottom',
        align: 'right',
        style: {
          fontSize: '20px',
          fontWeight: 'bold',
          color: '#0C55B8',
          backgroundColor: '#FFFFFF',
        },
      },
    },
    tooltip: {
      enabled: enableTooltip,
      formatter: toolTipFormatter,
      borderRadius: 10,
      // backgroundColor: null,
      // borderWidth: 0,
      // shadow: false,
      useHTML: true,
      padding: 0,
    },
    exporting: {
      enabled: exportMap,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        dataLabels: {
          allowOverlap: true,
          crop: false,
          overflow: 'none',
        },
        stickyTracking: true,
      },
      map: {
        enableMouseTracking: enableMouseTracking,
        point: {
          events: {
            select: function () {
              mapEvent(
                mapType,
                this.options,
                history,
                dashboardType,
                toggleEnabled()
              )
              return false
            },
            unselect: function () {
              //TODO: check if we are unselecting what is already selected and remove it form the hash
              // history.push({ hash: null })
            },
          },
        },
      },
    },
  }
}

export default getMapOptions
